import React from 'react';
import CustomRadio from './style';
import { Radio } from '@mui/material';

const Index = ({ label, value, onChange, name }) => {
  return (
    <CustomRadio
      control={
        <Radio
          value={value}
          onChange={onChange && onChange}
          name={name && name}
          sx={{
            color: '#5E70CC',
            '&.Mui-checked': {
              color: '#5E70CC',
            },
          }}
        />
      }
      label={label}
    />
  );
};

export default Index;
